import {useEvents} from "@/hooks/useNamEvents.ts";
import {EventListing} from "@/types/event.ts";

export default function NamEventsSection() {


    const {data, isLoading, isError, error, refetch, isFetching} = useEvents({
        page: 0, size: 3, sort: {field: "startTime", dir: "ASC"},
    });

    const items = data?.items ?? [];

    if (!data) return null;

    return (
        <section className="bg-white py-16 sm:py-22">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-4xl font-semibold tracking-tight text-blue-900 sm:text-5xl">
                        Komende Gebeure
                    </h2>
                    <p className="mt-2 text-lg/8 text-gray-600">
                        Ontdek opwindende geleenthede en aktiwiteite wat binnekort plaasvind. Moenie die aksie misloop
                        nie!
                    </p>
                </div>

                <div className="mt-12">
                    <div
                        className="grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                        {items.map((event) => (
                            <GridItem key={event.id}
                                      event={event} onView={() => {
                                window.open("https://www.nam-events.com/explore/" + event.id, "_blank");
                            }}/>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

// type Props = {
//     items: EventListing[];
//     isLoading?: boolean;
//     isError?: boolean;
// };
//
// export function EventsGrid({
//                                items,
//                                isLoading,
//                                isError,
//                            }: Props) {
//
//     return (
//         <>
//             <div className="mx-auto">
//
//                 {isLoading && <LoadingGridItems/>}
//
//                 {isError && <p className="mt-6 text-sm text-red-600 text-center">Failed to load News.</p>}
//
//                 {items.length === 0 && !isLoading && !isError && (
//                     <p className="mt-6 text-sm text-gray-600 text-center">No Events found.</p>
//                 )}
//
//                 <div
//                     className="grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 lg:mx-0 lg:max-w-none lg:grid-cols-3">
//                     {items.map((event) => (
//                         <article key={event.id} className="flex flex-col items-start justify-between">
//
//                             {/* Media */}
//                             <a href={"https://www.nam-events.com/explore/" + event.id}
//                                target="_blank"
//                                rel="noopener noreferrer"
//                                className="relative">
//                                 <div className="relative w-full">
//                                     <img
//                                         alt={event.name}
//                                         src={event.imageUrl}
//                                         className="w-full rounded-2xl bg-gray-100 object-cover  aspect-[1/1]"
//                                     />
//                                     <div className="absolute inset-0 rounded-2xl ring-1 ring-gray-900/10"/>
//                                 </div>
//                             </a>
//
//                             {/* Meta + Content */}
//                             <div className="flex max-w-xl grow flex-col justify-between">
//                                 <div className="mt-8 flex items-center gap-x-4 text-sm justify-between">
//                                     <time dateTime={event.startsAt} className="text-gray-600">
//                                         {format(new Date(event.startDate), 'MMM d, yyyy HH:mm')}
//                                     </time>
//
//                                     {event.category && (
//                                         <a
//                                             className="relative z-10 rounded-full bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100"
//                                         >
//                                             {event.category}
//                                         </a>
//                                     )}
//                                 </div>
//
//                                 <div className="group relative grow">
//                                     <h3 className="mt-3 text-lg/6 font-semibold text-blue-900 group-hover:text-gray-600">
//                                         <a href={"https://www.nam-events.com/event?id=" + event.id}
//                                            target="_blank"
//                                            rel="noopener noreferrer"
//                                            className="relative">
//                                             <span className="absolute inset-0" aria-hidden="true"/>
//                                             {event.name}
//                                         </a>
//                                     </h3>
//                                     <p className="mt-5 line-clamp-3 text-md text-gray-600">
//                                         {event.description}
//                                     </p>
//                                 </div>
//                             </div>
//                         </article>
//                     ))}
//                 </div>
//
//                 <div className="mt-12 flex justify-center">
//                     <a
//                         href={"https://www.nam-events.com/events"}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         className="inline-flex items-center rounded-md bg-blue-900 px-3 py-2 text-md font-semibold text-white hover:bg-blue-800 disabled:opacity-60"
//                     >
//                         Ontdek meer
//                     </a>
//                 </div>
//             </div>
//         </>
//     );
// }

export function GridItem({event, onView}: { event: EventListing; onView: () => void }) {
    const venue = event.location || "Venue TBA";
    const loc = event.address || "";

    return (
        <article className="flex flex-col items-start justify-between">
            <div className="relative w-full">
                <div className="aspect-square w-full overflow-hidden rounded-lg ">
                    <img
                        alt={event.name}
                        src={event.imageUrl || "https://picsum.photos/800/800"}
                        className="h-full w-full object-contain cursor-pointer"
                        loading="lazy"
                        decoding="async"
                        onClick={onView}
                    />
                </div>
            </div>

            <div className="flex max-w-xl grow flex-col justify-between">
                <div className="mt-8 flex items-center gap-x-4 text-xs">
                    <time dateTime={event.startsAt} className="text-gray-500">
                        <dd>{event.startsAt}</dd>
                    </time>
                    <a className="rounded-full text-sm bg-gray-50 px-3 py-1.5 font-medium text-gray-600 hover:bg-gray-100">
                        {event.category}
                    </a>
                </div>
                <div className="group relative grow">
                    <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600">
                        <a onClick={onView} className="cursor-pointer">
                            <span className="absolute inset-0"/>
                            {event.name}
                        </a>
                    </h3>
                    {event.description && (
                        <p className="mt-5 text-md/8 text-gray-600 line-clamp-3">
                            {event.description}
                        </p>
                    )}
                    {event.organizerName && (
                        <p className="mt-5 text-sm font-medium text-gray-500">
                            Hosted by {event.organizerName}
                        </p>
                    )}
                </div>
                <div className="relative mt-4 flex items-center gap-x-4 justify-self-end">
                    <div className="text-sm/6">
                        <p className="font-semibold text-gray-900">
                            <a>
                                <span className="absolute inset-0"/>
                                {venue}
                            </a>
                        </p>
                        <p className="text-gray-600">{loc}</p>
                    </div>
                </div>
            </div>
        </article>
    )
}